// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as React$1 from "@sentry/react";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./HyperLogger.bs.js";

let errorIcon = JsxRuntime.jsxs("svg", {
  children: [
    JsxRuntime.jsx("path", {
      d: "M73.73 398.49C86.92 453.5 174.24 496 280 496M312 304H264a40 40 0 00-40 40v24a32 32 0 0032 32h0a32 32 0 0032-32v-4a12 12 0 0112-12h12",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }),
    JsxRuntime.jsx("path", {
      d: "M120,352H108a12,12,0,0,0-12,12v4a32,32,0,0,1-64,0V344a40,40,0,0,1,40-40h48",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }),
    JsxRuntime.jsx("path", {
      d: "M160,264h27.2q11.6,0,23.189,0c3.22,0,5.97-.155,8.887.877,3.47,1.226,4.593,4.619,9.168,3.25,4.705-1.408,6.016-5.086,11.556-4.127",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }),
    JsxRuntime.jsx("line", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8",
      x1: "240",
      x2: "288",
      y1: "128",
      y2: "208"
    }),
    JsxRuntime.jsx("path", {
      d: "M288,128c-2.072,3.453-3.863,7.874-6.512,10.853-3.167,3.563-10.091,5.347-9.376,11.508.38,3.278,2.813,6.644,1.294,9.574-1,1.924-3.305,2.7-4.969,4.086-6.256,5.221-1.762,16.789-7.45,22.623-8.539,8.759-16,15.234-28.222,14.63",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }),
    JsxRuntime.jsx("line", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8",
      x1: "120",
      x2: "168",
      y1: "128",
      y2: "208"
    }),
    JsxRuntime.jsx("path", {
      d: "M168,128c-2.142,3.57-4.093,8.789-7.386,11.311-4.942,3.783-11.6,2.606-12.25,11.195-.218,2.885.646,5.866-.189,8.635-1.884,6.246-10.446,7.178-15.029,11.82-3.055,3.094-4.084,7.6-4.984,11.852C126.194,192.122,124.9,199.849,120,208",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }),
    JsxRuntime.jsx("path", {
      d: "M168,264h32a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16h0a16,16,0,0,1-16-16V264A0,0,0,0,1,168,264Z",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }),
    JsxRuntime.jsx("path", {
      d: "M72,304a652.669,652.669,0,0,0-3.127-67.367C66.478,213.265,72,191.111,72,168a152,152,0,0,1,304,0v70.071c0,17.689-2.939,37.871.849,54.981a158.13,158.13,0,0,1,2.545,57.075c-1.179,8.136-3,16.563-.638,24.438,6.368,21.233,27.016,20.563,44.877,19.524,21.843-1.272,43.7-5.16,64.317-12.589.03.83.05,1.66.05,2.5,0,43.21-45.44,80.71-112,99.38C347.28,491.44,314.63,496,280,496c-105.76,0-193.08-42.5-206.27-97.51",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }),
    JsxRuntime.jsx("path", {
      d: "M342.153 74.512l-21.939 27.094M352.83 95.734l-30.147 39.31M102.509 437.932c12.07-13.545 24.072-26.889 36.9-39.716M117.17 454.577l26.994-27.829",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })
  ],
  id: "dead-ghost",
  height: "50",
  width: "50",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
});

function ErrorBoundary$ErrorTextAndImage(props) {
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let message;
  switch (props.level) {
    case "Top" :
      message = "We'll be back with you shortly :)";
      break;
    case "RequestButton" :
    case "PaymentMethod" :
      message = "Try another payment method :)";
      break;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: errorIcon,
          style: {
            marginLeft: "1rem"
          }
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "Oops, something went wrong!"
            }),
            JsxRuntime.jsx("div", {
              children: message,
              className: "text-sm"
            })
          ],
          className: "flex flex-col items-center justify-center",
          style: {
            marginLeft: "3rem"
          }
        })
      ],
      className: "flex flex-row  items-center m-6"
    }),
    ref: Primitive_option.some(props.divRef),
    className: "flex  items-center",
    style: {
      backgroundColor: themeObj.colorBackground,
      borderColor: themeObj.borderColor,
      borderRadius: themeObj.borderRadius,
      color: themeObj.colorPrimary
    }
  });
}

let ErrorTextAndImage = {
  make: ErrorBoundary$ErrorTextAndImage
};

function ErrorBoundary$ErrorCard(props) {
  let publishableKey = props.publishableKey;
  let componentName = props.componentName;
  let level = props.level;
  let error = props.error;
  let beaconApiCall = data => {
    if (data.length <= 0) {
      return;
    }
    let logData = JSON.stringify(data.map(HyperLogger$OrcaPaymentPage.logFileToObj));
    navigator.sendBeacon(__SDK_CONFIG__.logEndpoint, logData);
  };
  React.useEffect(() => {
    let loggingLevel = __SDK_CONFIG__.loggingLevel;
    let enableLogging = __SDK_CONFIG__.enableLogging;
    if (enableLogging && [
        "DEBUG",
        "INFO",
        "WARN",
        "ERROR"
      ].includes(loggingLevel)) {
      let errorDict = Utils$OrcaPaymentPage.getDictFromJson(error);
      errorDict["componentName"] = componentName;
      let errorLog_timestamp = Date.now().toString();
      let errorLog_version = __SDK_CONFIG__.repoVersion;
      let errorLog_value = JSON.stringify(errorDict);
      let errorLog_platform = window.navigator.platform;
      let errorLog_browserName = Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[0], "Others");
      let errorLog_browserVersion = Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[1], "0");
      let errorLog_userAgent = window.navigator.userAgent;
      let errorLog_metadata = null;
      let errorLog = {
        timestamp: errorLog_timestamp,
        logType: "ERROR",
        category: "USER_ERROR",
        source: "orca-elements",
        version: errorLog_version,
        value: errorLog_value,
        sessionId: "",
        merchantId: publishableKey,
        paymentId: "",
        appId: "",
        platform: errorLog_platform,
        browserName: errorLog_browserName,
        browserVersion: errorLog_browserVersion,
        userAgent: errorLog_userAgent,
        eventName: "SDK_CRASH",
        latency: "",
        firstEvent: false,
        paymentMethod: "",
        metadata: errorLog_metadata
      };
      beaconApiCall([errorLog]);
    }
  }, []);
  let match = React.useState(() => 0.0);
  let setDivH = match[1];
  let divH = match[0];
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let iframeId = keys.iframeId;
  let divRef = React.useRef(null);
  React.useEffect(() => {
    let observer = new ResizeObserver(entries => {
      entries.forEach(item => setDivH(param => item.contentRect.height));
    });
    let r = divRef.current;
    if (!(r == null)) {
      observer.observe(r);
    }
    return () => observer.disconnect();
  }, []);
  React.useEffect(() => {
    switch (level) {
      case "Top" :
        Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "iframeHeight",
            divH + 1.0
          ],
          [
            "iframeId",
            iframeId
          ]
        ]);
        break;
      case "RequestButton" :
      case "PaymentMethod" :
        break;
    }
  }, [
    divH,
    iframeId
  ]);
  switch (level) {
    case "RequestButton" :
      return null;
    case "Top" :
    case "PaymentMethod" :
      return JsxRuntime.jsx(ErrorBoundary$ErrorTextAndImage, {
        divRef: divRef,
        level: level
      });
  }
}

let ErrorCard = {
  make: ErrorBoundary$ErrorCard
};

function defaultFallback(e, level, componentName, publishableKey) {
  return JsxRuntime.jsx(ErrorBoundary$ErrorCard, {
    error: e,
    level: level,
    componentName: componentName,
    publishableKey: publishableKey
  });
}

function ErrorBoundary(props) {
  let __publishableKey = props.publishableKey;
  let componentName = props.componentName;
  let __level = props.level;
  let __renderFallback = props.renderFallback;
  let __renderFallback_value = __renderFallback !== undefined ? __renderFallback : defaultFallback;
  let __level_value = __level !== undefined ? __level : "PaymentMethod";
  let __publishableKey_value = __publishableKey !== undefined ? __publishableKey : "";
  return JsxRuntime.jsx(React$1.ErrorBoundary, {
    fallback: e => __renderFallback_value(e, __level_value, componentName, __publishableKey_value),
    children: props.children
  });
}

let make = ErrorBoundary;

export {
  errorIcon,
  ErrorTextAndImage,
  ErrorCard,
  defaultFallback,
  make,
}
/* errorIcon Not a pure module */
